/** TanStack Query keys. Workspace-scoped data always carries the workspace id. */
export const queryKeys = {
  me: ["me"] as const,
  templates: ["industry-templates"] as const,
  setupGoals: ["setup-goals"] as const,
  templatePreview: (templateKey: string, language: string, goals: string) => ["industry-templates", "preview", templateKey, language, goals] as const,
  templateDraft: (wsId: string, templateKey: string, setup: string) => ["ws", wsId, "setup-draft", "template", templateKey, setup] as const,
  countries: ["meta", "countries"] as const,
  slug: (slug: string) => ["slug-available", slug] as const,
  invitation: (token: string) => ["invitation", token] as const,
  resetToken: (token: string) => ["reset-validate", token] as const,
  oauth: (provider: string) => ["oauth-availability", provider] as const,
  workspace: (wsId: string) => ["ws", wsId, "workspace"] as const,
  permissions: (wsId: string, agentId: string | null) => ["ws", wsId, "permissions", agentId] as const,
  nav: (wsId: string, agentId: string | null) => ["ws", wsId, "nav", agentId] as const,
  /** Every nav query of a workspace (any agent). */
  navAll: (wsId: string) => ["ws", wsId, "nav"] as const,
  notifications: (wsId: string) => ["ws", wsId, "notifications"] as const,
  roles: (wsId: string) => ["ws", wsId, "roles"] as const,
  permissionCatalogue: (wsId: string) => ["ws", wsId, "permission-catalogue"] as const,
  members: (wsId: string) => ["ws", wsId, "members"] as const,
  invitations: (wsId: string) => ["ws", wsId, "invitations"] as const,
  teams: (wsId: string) => ["ws", wsId, "teams"] as const,
  preview: (wsId: string, key: string) => ["ws", wsId, "preview", key] as const,
} as const;
